import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

// Import paths
import { APP_PATHS } from './paths';

// Import components
import RouteWithLayout from 'components/elements/molecules/Layout/RouteWithLayout';
import ProtectedUserLogged from 'components/hoc/ProtectedUserLogged';

import SignInView from 'views/SignIn'
import SignUpView from 'views/SignUp'
import VerificationView from 'views/Verification'
import ForgotPasswordView from 'views/ForgotPassword'
import StartView from 'views/Start'
import CarsView from 'views/Cars'
import CarView from 'views/Car'
import BookingConfirmationView from 'views/BookingConfirmation'
import PaymentView from 'views/Payment'


const {
	SIGN_IN,
	SIGN_UP,
	VERIFICATION,
	START,
	CAR,
	CARS,
	PAYMENT,
	BOOKING_CONFIRMATION,
	FORGOT_PASSWORD
} = APP_PATHS;

const Routes = () => (
	<React.Suspense fallback={<div>Loader</div>}>
		<Switch>
			<Redirect exact from="/" to={START} />
			<RouteWithLayout path={START} component={StartView} />
			<RouteWithLayout path={CAR} component={CarView} />
			<RouteWithLayout
				path={BOOKING_CONFIRMATION}
				component={BookingConfirmationView}
			/>
			<RouteWithLayout path={PAYMENT} component={PaymentView} />
			<RouteWithLayout path={CARS} component={CarsView} />
			<ProtectedUserLogged path={SIGN_IN} component={SignInView} />
			<ProtectedUserLogged path={SIGN_UP} component={SignUpView} />
			<ProtectedUserLogged path={VERIFICATION} component={VerificationView} />
			<ProtectedUserLogged
				path={FORGOT_PASSWORD}
				component={ForgotPasswordView}
			/>
			<Redirect to={START} />
		</Switch>
	</React.Suspense>
);

export default Routes;
